import {
  useContext,
  createContext,
  useState,
  type Dispatch,
  type SetStateAction,
  type PropsWithChildren,
} from 'react';

/**
 * 外部共有プレビューページのパスワードの state
 */
const passwordContext = createContext<null | string>(null);
const setPasswordContext = createContext<
  Dispatch<SetStateAction<null | string>>
>(() => undefined);

export function PasswordProvider({
  children,
  initialValue = null,
}: PropsWithChildren<{readonly initialValue?: null | string}>) {
  const [password, setPassword] = useState<null | string>(initialValue);

  return (
    <passwordContext.Provider value={password}>
      <setPasswordContext.Provider value={setPassword}>
        {children}
      </setPasswordContext.Provider>
    </passwordContext.Provider>
  );
}

export function usePreviewPagePasswordValue() {
  return useContext(passwordContext);
}

export function useSetPreviewPagePassword() {
  return useContext(setPasswordContext);
}
